<template>
	<!-- 绝对的垂直居中组件 -->
	<span style="display: inline-flex; align-items: center">{{ "\u200b" }}<slot /></span>
</template>

<script>
export default {
	name: "StrutAlignCenter",
};
</script>
